import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';

import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import Computer from 'mbs-ui-shared@models/Computer';

@UntilDestroy()
@Component({
  selector: 'mbs-remote-connection-not-available-modal-component',
  templateUrl: './remote-connection-not-available-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class RemoteConnectionNotAvailableModalComponent {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  computer: Computer;
  mbsPopupType = MbsPopupType;

  get computerName(): string {
    return Computer.getComputerName(this.computer);
  }

  ngOnInit(): void {
    if (this.baseModal.data) {
      this.computer = this.baseModal.data.computer;
    }
  }
}
